import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, normalizeStyle as _normalizeStyle, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5258e03b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "element-content" }

import { computed, PropType } from 'vue'
import { PPTAudioElement } from '@/types/slides'


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseAudioElement',
  props: {
  elementInfo: {
    type: Object as PropType<PPTAudioElement>,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const audioIconSize = computed(() => {
  return Math.min(props.elementInfo.width, props.elementInfo.height) + 'px'
})

return (_ctx: any,_cache: any) => {
  const _component_IconVolumeNotice = _resolveComponent("IconVolumeNotice")!

  return (_openBlock(), _createElementBlock("div", {
    class: "base-element-audio",
    style: _normalizeStyle({
      top: __props.elementInfo.top + 'px',
      left: __props.elementInfo.left + 'px',
      width: __props.elementInfo.width + 'px',
      height: __props.elementInfo.height + 'px',
    })
  }, [
    _createElementVNode("div", {
      class: "rotate-wrapper",
      style: _normalizeStyle({ transform: `rotate(${__props.elementInfo.rotate}deg)` })
    }, [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_IconVolumeNotice, {
          class: "audio-icon",
          style: _normalizeStyle({
            fontSize: _unref(audioIconSize),
            color: __props.elementInfo.color,
          })
        }, null, 8, ["style"])
      ])
    ], 4)
  ], 4))
}
}

})